import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["fields", "formOptions", "WizardStepProps"];
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import FormSpy from '@data-driven-forms/react-form-renderer/form-spy';
import WizardStepButtons from './step-buttons';
import './wizard-step.css';

var WizardStep = function WizardStep(_ref) {
  var fields = _ref.fields,
      formOptions = _ref.formOptions,
      WizardStepProps = _ref.WizardStepProps,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    className: "ddorg__ant-component-mapper_wizard-step"
  }, WizardStepProps), fields.map(function (item) {
    return formOptions.renderForm([item], formOptions);
  })), /*#__PURE__*/React.createElement(FormSpy, null, function () {
    return /*#__PURE__*/React.createElement(WizardStepButtons, _extends({
      formOptions: formOptions
    }, rest));
  }));
};

WizardStep.propTypes = {
  fields: PropTypes.array,
  formOptions: PropTypes.shape({
    renderForm: PropTypes.func.isRequired
  }).isRequired,
  WizardStepProps: PropTypes.object
};
WizardStep.defaultProps = {
  fields: []
};
export default WizardStep;